// extracted by mini-css-extract-plugin
module.exports = {"moreButton":"_2pvpF","openButton":"_2esfZ","arrow":"_26g-d","arrowUp":"DX9kF","actionText":"ciWzz","preLabel":"_31H8y"};